/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceSecretManagerCredentialsInfo } from './resourceSecretManagerCredentialsInfo';
import { ResourceProvider } from './resourceProvider';
import { ResourceAssignmentDetails } from './resourceAssignmentDetails';
import { ResourceState } from './resourceState';
import { ResourceType } from './resourceType';
import { ResourceCategory } from './resourceCategory';
import { ResourceAssignmentHistory } from './resourceAssignmentHistory';


export interface DetailedResourceInfo { 
    resource_id?: string;
    provider?: ResourceProvider;
    category?: ResourceCategory;
    state?: ResourceState;
    type?: ResourceType;
    managed?: boolean;
    sharable?: boolean;
    assigned_vcf_orgs?: Array<ResourceAssignmentDetails>;
    assignment_history?: Array<ResourceAssignmentHistory>;
    metadata?: object;
    /**
     * Any comment related to Resource to be onboarded.
     */
    note?: string;
    secret_manager_credentials?: Array<ResourceSecretManagerCredentialsInfo>;
    created_by?: string;
    created_time?: Date;
    updated_by?: string;
    updated_time?: Date;
}
export namespace DetailedResourceInfo {
}


